export interface IWageAndTravelVerifyValidation {
    ssnDecrypted: boolean,
    incomeIrsYear: boolean,
    incomeIrsYearGross: boolean,
    startDate: boolean,
    endDate: boolean,
    incomeGross: boolean
}